import React from "react";
import ValidationText from "../../utils/validation/ValidationText.js";
import MultiSelectDropdown from "../dropdown/MultiSelectDropdown.js";

const PurchaseOrderDetails = (props) => {
    return (
        <div className="item-form">
            <div className="form-table mb-3.5 ">
                <div className="item-grp !p-3.5 rounded-[10px]">
                    {/* <span
                        style={{
                            marginBottom: "5px",
                            fontSize: "16px",
                            fontWeight: "700",
                            textDecoration: "underline",
                        }}
                    >
                        Party Details
                    </span> */}
                    <div className="item-inner-grp flex gap-2.5 mb-3">
                        <div className="input-grp" style={{ width: "60%" }}>
                            <label>Party Name</label>
                            <MultiSelectDropdown
                                className={`${props.validState?.error?.partyId ? "errorInput" : ""}`}
                                drpIdentity="partyId"
                                options={props.partyDropdownList}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                onChange={(selected) => props.setFilterParameters(selected, 'partyId')}
                                allowSelectAll={false}
                                value={props.partyDropdownList.filter(
                                    (party) => party.value === props.purchaseOrderDetails.partyId
                                )}
                                isDisabled={props.isAllFieldDisable}
                            />
                            {/* <ValidationText error={props.validState.error.partyId} /> */}
                        </div>
                        <div className="input-grp" style={{ width: "60%" }}>
                            <label>Email</label>
                            <input
                                className={` inputFocus ${props.validState?.error?.email ? "errorInput" : ""}`}
                                type="text"
                                style={{ width: "100%" }}
                                id="email"
                                name="email"
                                autoComplete="off"
                                value={props.purchaseOrderDetails.email}
                                onChange={(event) => props.handleChange(event, "email")}
                                disabled={props.isAllFieldDisable}
                            />
                            {/* <ValidationText error={props.validState.error.email} /> */}
                        </div>
                    </div>
                    <div className="item-inner-grp flex gap-2.5">
                        <div className="input-grp" style={{ width: "25%" }}>
                            <label>Delivery Before</label>
                            <input
                                className={`inputFocus ${props.validState?.error?.deliveryBefore ? "errorInput" : ""}`}
                                type="date"
                                id="deliveryBefore"
                                name="deliveryBefore"
                                autoComplete="off"
                                value={props.purchaseOrderDetails.deliveryBefore}
                                onChange={(event) => props.handleChange(event, "deliveryBefore")}
                                disabled={props.isAllFieldDisable}
                            />
                            {/* <ValidationText error={props.validState.error.deliveryBefore} /> */}
                        </div>
                        <div className="input-grp" style={{ width: "25%" }}>
                            <label>Ref. No</label>
                            <input
                                className={`inputFocus ${props.validState?.error?.refNo ? "errorInput" : ""}`}
                                type="text"
                                id="refNo"
                                name="refNo"
                                autoComplete="off"
                                value={props.purchaseOrderDetails.refNo}
                                onChange={(event) => props.handleChange(event, "refNo")}
                                disabled={props.isAllFieldDisable}
                            />
                            {/* <ValidationText error={props.validState.error.refNo} /> */}
                        </div>
                        <div className="input-grp" style={{ width: "25%" }}>
                            <label>Ref. Date</label>
                            <input
                                className={`inputFocus ${props.validState?.error?.refDate ? "errorInput" : ""}`}
                                type="date"
                                id="refDate"
                                name="refDate"
                                autoComplete="off"
                                value={props.purchaseOrderDetails.refDate}
                                onChange={(event) => props.handleChange(event, "refDate")}
                                disabled={props.isAllFieldDisable}
                            />
                            {/* <ValidationText error={props.validState.error.refDate} /> */}
                        </div>
                        <div className="input-grp" style={{ width: "25%" }}>
                            <label>Material Type</label>
                            <select
                                className={` ${props.validState?.error?.materialType ? "errorInput" : ""}`}
                                value={props.purchaseOrderDetails.materialType}
                                onChange={(e) => props.handleDropdownChange(e, "materialType")}
                                disabled={props.isAllFieldDisable}
                            >
                                <option>Select</option>
                                {props.typeList.map((x, key) => (
                                    <option key={key} value={x.grnType}>
                                        {x.grnType}
                                    </option>
                                ))}
                            </select>
                            {/* <ValidationText error={props.validState.error.materialType} /> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="innerForm-table">
                <div className="innerItem-grp !p-3.5">
                    {/* <span
                        style={{
                            fontSize: "16px",
                            fontWeight: "700",
                            textDecoration: "underline",
                        }}
                    >
                        Purchase Details
                    </span> */}
                    <div className="innerItem-inner-grp flex gap-2.5 !mt-0">
                        <div className="input-grp">
                            <label>GST</label>
                            <select
                                className={` ${props.validState?.error?.gstApplicable ? "errorInput" : ""}`}
                                value={props.purchaseOrderDetails.gstApplicable}
                                onChange={(e) => props.handleDropdownChange(e, "gstApplicable")}
                                disabled={props.isAllFieldDisable}
                            >
                                <option>Select</option>
                                {props.gstApplicableList.map((x, key) => (
                                    <option key={key} value={x.gst}>
                                        {x.gst}
                                    </option>
                                ))}
                            </select>
                            {/* <ValidationText error={props.validState.error.gstApplicable} /> */}
                        </div>

                        <div className="input-grp">
                            <label>Payment Term</label>
                            <select
                                className={` ${props.validState?.error?.paymentTerm ? "errorInput" : ""}`}
                                value={props.purchaseOrderDetails.paymentTerm}
                                onChange={(e) => props.handleDropdownChange(e, "paymentTerm")}
                                disabled={props.isAllFieldDisable}
                            >
                                <option>Select</option>
                                {props.payMentTermList.map((x, key) => (
                                    <option key={key} value={x.paymentTerm}>
                                        {x.paymentTerm}
                                    </option>
                                ))}
                            </select>
                            {/* <ValidationText error={props.validState.error.paymentTerm} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Freight</label>
                            <select
                                className={` ${props.validState?.error?.freight ? "errorInput" : ""}`}
                                value={props.purchaseOrderDetails.freight}
                                onChange={(e) => props.handleDropdownChange(e, "freight")}
                                disabled={props.isAllFieldDisable}
                            >
                                <option>Select</option>
                                {props.freightList.map((x, key) => (
                                    <option key={key} value={x.freight}>
                                        {x.freight}
                                    </option>
                                ))}
                            </select>
                            {/* <ValidationText error={props.validState.error.freight} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Transporter</label>
                            <select
                                className={` ${props.validState?.error?.transportBy ? "errorInput" : ""}`}
                                value={props.purchaseOrderDetails.transportBy}
                                onChange={(e) => props.handleDropdownChange(e, "transportBy")}
                                disabled={props.isAllFieldDisable}
                            >
                                <option>Select</option>
                                {props.transportList.map((x, key) => (
                                    <option key={key} value={x.transport}>
                                        {x.transport}
                                    </option>
                                ))}
                            </select>
                            {/* <ValidationText error={props.validState.error.transportBy} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Booking At</label>
                            <select
                                className={` ${props.validState?.error?.bookingArea ? "errorInput" : ""}`}
                                value={props.purchaseOrderDetails.bookingArea}
                                onChange={(e) => props.handleDropdownChange(e, "bookingArea")}
                                disabled={props.isAllFieldDisable}
                            >
                                <option>Select</option>
                                {props.bookingAreaList.map((x, key) => (
                                    <option key={key} value={x.bookingArea}>
                                        {x.bookingArea}
                                    </option>
                                ))}
                            </select>
                            {/* <ValidationText error={props.validState.error.bookingArea} /> */}
                        </div>
                    </div>
                </div>
                <div
                    className="innerItem-grp !p-3.5 grid mt-3.5"

                >
                    {/* <span
                        style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            textDecoration: "underline",
                        }}
                    >
                        Address Details
                    </span> */}
                    <div
                        className="innerItem-inner-grp grid grid-cols-2 mb-3 gap-2.5"
                    >
                        <div className="input-grp" style={{ width: "100%" }}>
                            <label>Address Line 1</label>
                            <input
                                className={`inputFocus ${props.validState?.error?.addressLine1 ? "errorInput" : ""}`}
                                type="text"
                                style={{ width: "100%" }}
                                id="addressLine1"
                                name="addressLine1"
                                autoComplete="off"
                                value={props.purchaseOrderDetails.addressLine1}
                                onChange={(event) => props.handleChange(event, "addressLine1")}
                                disabled={props.isAllFieldDisable}
                            />
                            {/* <ValidationText error={props.validState.error.addressLine1} /> */}
                        </div>
                        <div className="input-grp" style={{ width: "100%" }}>
                            <label>Address Line 2</label>
                            <input
                                className={`inputFocus ${props.validState?.error?.addressLine2 ? "errorInput" : ""}`}
                                type="text"
                                style={{ width: "100%" }}
                                id="addressLine2"
                                name="addressLine2"
                                autoComplete="off"
                                value={props.purchaseOrderDetails.addressLine2}
                                onChange={(event) => props.handleChange(event, "addressLine2")}
                                disabled={props.isAllFieldDisable}
                            />
                            {/* <ValidationText error={props.validState.error.addressLine2} /> */}
                        </div>
                    </div>
                    <div
                        className="innerItem-inner-grp grid grid-cols-3 gap-2.5 !mt-0"
                    >
                        <div className="input-grp" style={{ width: "100%" }}>
                            <label>City</label>
                            <input 
                              className={`inputFocus ${props.validState?.error?.city  ? "errorInput" : ""}`}
                                type="text"
                                style={{ width: "100%" }}
                                id="city"
                                name="city"
                                autoComplete="off"
                                value={props.purchaseOrderDetails.city}
                                onChange={(event) => props.handleChange(event, "city")}
                                disabled={props.isAllFieldDisable}
                            />
                            {/* <ValidationText error={props.validState.error.city} /> */}
                        </div>
                        <div className="input-grp" style={{ width: "100%" }}>
                            <label>State</label>
                            <input 
                              className={`inputFocus ${props.validState?.error?.state  ? "errorInput" : ""}`}
                                type="text"
                                style={{ width: "100%" }}
                                id="state"
                                name="state"
                                autoComplete="off"
                                value={props.purchaseOrderDetails.state}
                                onChange={(event) => props.handleChange(event, "state")}
                                disabled={props.isAllFieldDisable}
                            />
                            {/* <ValidationText error={props.validState.error.state} /> */}
                        </div>
                        <div className="input-grp" style={{ width: "100%" }}>
                            <label>Zip Code</label>
                            <input 
                              className={`inputFocus ${props.validState?.error?.zipCode  ? "errorInput" : ""}`}
                                type="number"
                                style={{ width: "100%" }}
                                id="zipCode"
                                name="zipCode"
                                autoComplete="off"
                                value={props.purchaseOrderDetails.zipCode}
                                onChange={(event) => props.handleChange(event, "zipCode")}
                                disabled={props.isAllFieldDisable}
                            />
                            {/* <ValidationText error={props.validState.error.zipCode} /> */}
                        </div>
                    </div>
                </div>
            </div>

            <div className="btn-grp mt-4" >
                <button
                    className="add-btn"
                    onClick={() => props.addEditPurchaseOrderDetails()}
                >
                    Next
                </button>
                <button
                    className="back-btn"
                    // onClick={() => props.resetPurchaseOrderDetails()}
                    onClick={() => props.openGridView()}
                >
                    Back
                </button>
            </div>
        </div>
    );
};

export default PurchaseOrderDetails;
